import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectMarkupsRoutes = [
  {
    path: 'markups',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Markups')
      },
      permissions: ['READ_MARKUP_RATES', 'READ_NETTO_COST']
    },
    children: [
      {
        path: 'rates',
        name: 'markupRatesList',
        component: wrapLegacyRoute('markupsRatesController', 'list')
      },
      {
        path: 'rates/create',
        name: 'markupRateCreate',
        component: wrapLegacyRoute('markupsRatesController', 'create')
      },
      {
        path: 'rates/:markupRateId(\\d+)',
        name: 'markupRateDetails',
        component: wrapLegacyRoute('markupsRatesController', 'details')
      }
    ]
  }
];

export default projectMarkupsRoutes;
